/**
 * newspaperSignOperationBtnsModule
 * description: newspaper渠道下操作按钮
 * author: Qian.qianchen 2019-03-26
 */
'use strict';
angular.module('newspaperSignOperationBtnsModule', []).directive('newspaperSignOperationBtns', ['editingCenterService', '$q', 'modalDialog', 'trsHttpService', 'editNewspaperService', 'sensitiveWordCheckService', function (editingCenterService, $q, modalDialog, trsHttpService, editNewspaperService, sensitiveWordCheckService) {
    return {
        restrict: 'E',
        replace: false,
        templateUrl: './editingCenter/iWo/fusionSign/directive/newspaperSignOperationBtns/newspaperSignOperationBtns_tpl.html',
        scope: {
            selectedArr: '=',
            callback: '&',
            paperid: '=',
            channelValue: '=',
        },
        link: function ($scope, iElement, attrs) {
            initStatus();

            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {};
            }

            /**
             * [getNewspaperType description] 获取报纸类型 采编版面还是照排版面
             * @return {[type]} [description]
             */
            function getNewspaperType() {
                var deffer = $q.defer();
                if ($scope.status.ISZHAOPAI !== undefined) {
                    deffer.resolve();
                } else {
                    editingCenterService.getSiteInfo($scope.$parent.data.channelValue).then(function (data) {
                        $scope.status.ISZHAOPAI = data.ISZHAOPAI != '0';
                        deffer.resolve();
                    });
                }
                return deffer.promise;
            }

            /**
             * [singleSignZp description]签发照排
             * @param  {[obj]} item [description]传入的列表项或者选中的数组
             * @return {[type]}      [description]null
             */
            $scope.signedDraft = function (item) {
                var array = !!item ? [item] : $scope.selectedArr;
                $scope.$parent.$parent.loadingPromise = sensitiveWordCheckService.SensitiveWordsAndCareful(array, '', 3).then(function () {
                    signZp(array);
                }, function () {
                    signZp(array);
                });
            };

            /**
             * [signZp description]稿件签发照排操作
             * @param  {[array]} item [description]被选中的稿件
             * @return {[type]}      [description]
             */
            function signZp(item) {
                var deffer = $q.defer();
                getNewspaperType().then(function () {
                    if (!$scope.status.ISZHAOPAI) {
                        editNewspaperService.stopSignZp(item, function (result) {
                            $scope.callback();
                            deffer.resolve();
                        }, function (result) {
                            if (angular.isDefined(result.reports[0])) {
                                result.paperid = $scope.paperid;
                                editNewspaperService.singZpInfo(result, function () {
                                    $scope.callback();
                                    deffer.resolve();
                                });
                            }
                        });
                    } else {
                        editNewspaperService.useSignZP(item, function (result) {
                            $scope.callback();
                            deffer.resolve();
                        }, function (result) {
                            if (angular.isDefined(result.reports[0])) {
                                result.paperid = $scope.paperid;
                                editNewspaperService.singZpInfo(result, function () {
                                    $scope.callback();
                                    deffer.resolve();
                                });
                            }
                        });
                    }
                });
                return deffer.promise;
            }
            // 批量撤稿弹窗
            $scope.retractView = function () {
                retractView($scope.selectedArr);
            };

            /**
             * [retractView description]撤稿函数
             * @param  {[array]} item [description]选中的稿件
             * @return {[type]}      [description]
             */
            function retractView(item) {
                var deffer = $q.defer();
                var transferData = {
                    'title': '撤稿',
                    'opinionTit': '撤稿原因',
                    'items': item,
                    'PaperId': $scope.paperid,
                    'queryMethod': 'queryShangBanDocs'
                };
                editNewspaperService.cancelSignedViews(transferData, function (result) {
                    var params = {
                        'SrcDocIds': result.SrcDocIds,
                        'Option': result.opinion ? result.opinion : '',
                        'serviceid': 'mlf_paper',
                        'methodname': 'doCheGao'
                    };
                    promptRequest(params, '撤稿成功').then(function () {
                        deffer.resolve();
                    });
                });
                return deffer.promise;
            }

            /**
             * [promptRequest description]具体操作数据请求成功后刷新列表
             * @param  {[obj]} params [description]请求参数
             * @param  {[string]} info   [description]提示语
             * @return {[type]}        [description]
             */
            function promptRequest(params, info) {
                var deffer = $q.defer();
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    modalDialog.alertType('', info, 'success', false, function () {
                        $scope.callback();
                        deffer.resolve();
                    });
                }, function () {
                    $scope.callback();
                    deffer.resolve();
                });
                return deffer.promise;
            }
        }
    };
}]);
